export const DELETE_ANNOUCEMENT_WARNING = 'Do you want to delete this Announcement?';
export const SHARE_FORM_WARNING = 'Are you sure you want to Send Form?';
export const SHARE_INTAKE_FORM_WARNING = 'Are you sure you want to Send Intake Form?';
export const DELETE_EMPLOYEE_WARNING = 'Are you sure you want to delete?';
export const DELETE_GOAL_WARNING = 'Do you want to delete this Goal?';
export const DELETE_LEARNING_OPP_WARNING = 'Do you want to delete this Learning Opportunities?';
export const DELETE_GLOBAL_GIVING_CAUSE = 'Do you want to delete this Global Cause?';
export const DELETE_TRAINING_RESOURCES_WARNING = 'Do you want to delete this Training Resources?';
export const PERFORMANCE_NOTE_DELETE_WARNING = 'Do you want to delete this Note ?';
export const ALL_SAVED_SEARCH_WARNING = 'Are you sure you want to delete all your saved searches?';
export const DELETE_SAVED_SEARCH_WARNING = 'Are you sure you want to delete your search?';
export const APPROVE_FORM_WARNING = 'Are you sure you want to Approve?';
export const CENCEL_REQUEST_WARNING = 'Are you sure you want to cancel?';
export const EXIT_FROM_IMPORT_TAB_WARNING = 'Do you want to exit from Import Tab?';
export const LOGOUT_WARNING = 'Do you want to logout?';
